import { Link } from 'react-router-dom';
import Status from '../general-components/Status';
import { ImplantMember } from '../../services/api/folderService';

interface ImplantMemberItemProps {
    implant: ImplantMember;
}

export const ImplantMemberItem = ({ implant }: ImplantMemberItemProps) => (
    <Link to={`/implant/${implant._id}`} className="block">
        <div className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-muted">
            <div className="h-7 w-7 flex-shrink-0">
                <Status status={implant['MRI-status'] ?? 0} small />
            </div>
            <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium text-foreground">
                    {implant.Model}
                </div>
                {implant.Type && (
                    <div className="mt-0.5 truncate text-xs font-medium text-subtle-foreground">
                        {implant.Type}
                    </div>
                )}
            </div>
        </div>
    </Link>
);
